// extracted by mini-css-extract-plugin
export default {"item-container":"styles_item-container__a5s3I"};